import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-0"}],["path",{"d":"M9 15.075l6 -6","key":"svg-1"}],["path",{"d":"M9 9.105v.015","key":"svg-2"}],["path",{"d":"M15 15.12v.015","key":"svg-3"}]]

const IconSquareRoundedPercentage = createReactComponent('outline', 'square-rounded-percentage', 'SquareRoundedPercentage', __iconNode);

export default IconSquareRoundedPercentage;